import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './footer-xsci.module.css'
// import responsive from "./footer-xsci-responsive.module.css";
import {faEnvelope, faLocationDot, faPhone} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";

const ContactSection = () => {
    const {t, i18n} = useTranslation();


    return (

        <div className={`col-md-3 col-12 my-sm-0 mt-5 ${styles.section_container}`}>
            <ul className="list-unstyled">
                <li className={`mt-md-3 mt-4 ${styles.section_title}`}>Contact</li>
                <li className={styles.section_li}>
                    <FontAwesomeIcon
                    icon={faEnvelope}
                    style={{
                        fontSize: "18px",
                        color: "#194A85",
                        cursor: "pointer",
                        paddingRight: "10px",
                    }}/>
                    info.garderielabelleetoile@gmail.com
                </li>
                <a className="nav-link active" aria-current="page" href="tel:6138888888">
                    <li className={styles.section_li}><FontAwesomeIcon
                        icon={faPhone}
                        style={{
                            fontSize: "18px",
                            color: "#194A85",
                            cursor: "pointer",
                            paddingRight: "10px"
                        }}/>

                        <a href="tel:438-883-6890" className="phone-link" style={{color:"black"}}>438-883-6890
                        </a>
                    </li>
                </a>

                <li className={styles.section_li}><FontAwesomeIcon
                    icon={faLocationDot}
                    style={{
                        fontSize: "18px",
                        color: "#194A85",
                        cursor: "pointer",
                        paddingRight: "10px"
                    }}/>
                    Av. Jean-Baptiste-Varin, La Prairie, QC J5R 6T8
                </li>
            </ul>
        </div>

    );
};

export default ContactSection;